import { OperationVariables, QueryResult } from "@apollo/client"

import { ImagesResponse, ProfilesMap, ServerCatalogResponse } from "uh-ui-cloud-material"

interface ModalContentStatusProps {
    status: 'loading' | 'ready' | 'error'
}

export interface InitialProfile {
    compute: string
    bandwidth: string
    disk: string
}

const getInitialHardwareByQueryParam = (location: Location, paramName: string):string => {
    return new URLSearchParams(location.search).get(paramName) || '0'
}

export const getInitialImage = (location: Location): number => {
    return parseInt(getInitialHardwareByQueryParam(location, 'imagem') || '0')
}

export const getGroupQueryParam = (location: Location): string | null => {
    return new URLSearchParams(location.search).get('group')
}

export const getInitialHardware = (location: Location): InitialProfile => {
    const profile = parseInt(getInitialHardwareByQueryParam(location, 'profile') || '0')
    const profileMap = ProfilesMap[profile]
    return profileMap
}

export const getInitialCollapse = (location: Location): boolean => {
    const showConfig = getInitialHardwareByQueryParam(location, 'showConfig');
    return showConfig ? !!!parseInt(showConfig): false
}

export const getStatusByHookGraphql = function (
    query1:QueryResult<ImagesResponse, OperationVariables>,
    query2:QueryResult<ServerCatalogResponse, OperationVariables>
): ModalContentStatusProps['status'] {
    if (query1.loading || query2.loading) return 'loading'
    if (query1.error || query2.error) return 'error'
    return 'ready'
}

export const removeCompute512MB = (data:ServerCatalogResponse)=> {
    if (!data) return null;

    return {
        ...data,
        serverCatalog: {
            ...data.serverCatalog,
            computes: data.serverCatalog.computes.slice(1),
            bandwidths: {
                ...data.serverCatalog.bandwidths,
                sizes: data.serverCatalog.bandwidths.sizes.slice(1)
            }
        }
    };
}